import React, { useMemo } from 'react'

import Header from '../../common/components/Header'
import Select from '../../common/components/Select'
import Checkbox from '../../common/components/Checkbox'
import TextArea from '../../common/components/TextArea'
import Button, { BUTTON_STYLES } from '../../common/components/Button'

import EditSegmentList from './EditSegmentList'

import { useAgencies, useReasons, useCreateClosure } from '../hooks'

import styles from './Form.module.css'

const AddClosureForm = () => {
  const [
    { agencyId, reason, notes, pending, error },
    { create, zoomTo, setAgencyId, setNotes, setReason, setPending },
  ] = useCreateClosure()
  const agencies = useAgencies()
  const reasons = useReasons()
  const agencyOptions = useMemo(
    () =>
      agencies
        ? [
            { label: 'Select a Closing Agency', value: -1 },
            ...agencies.map((i) => ({ label: i.name, value: i.id })),
          ]
        : [],
    [agencies]
  )
  const reasonOptions = useMemo(
    () =>
      reasons
        ? [
            { label: 'Select a Reason', value: -1 },
            ...reasons.map((i) => ({ label: i, value: i })),
          ]
        : [],
    [reasons]
  )

  return (
    <div className={styles.container}>
      <Header>Create Closure</Header>
      <div>
        <Select
          label="Closing Agency"
          options={agencyOptions}
          value={agencyId}
          onChange={setAgencyId}
        />
        <Select
          label="Reason"
          options={reasonOptions}
          value={reason}
          onChange={setReason}
        />
        <TextArea
          label="Notes"
          placeholder="Enter any notes about the closure."
          rows={10}
          value={notes}
          onChange={setNotes}
        />
        <Button
          text={<i className="fas fa-crosshairs fa-2x"></i>}
          style={BUTTON_STYLES.NO_BORDER}
          onClick={zoomTo}
        />
        <Checkbox
          checked={pending}
          label="Start as Pending?"
          onChange={setPending}
        />
        <EditSegmentList />
        {error && <div className={styles.errorMessage}>{error}</div>}
        <Button text="Create" style={BUTTON_STYLES.PRIMARY} onClick={create} />
      </div>
    </div>
  )
}

export default AddClosureForm
